"use client";

import { ThemeProvider as NextThemesProvider, type ThemeProviderProps } from "next-themes";

// Thin client-side wrapper around next-themes so the root (server) layout can
// mount it without triggering a "Cannot use hooks in a server component" error.
// All the useful props are forwarded.
export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
